import { Helmet } from 'react-helmet-async';
import { useSettingsStore } from '@/data/settingsStore';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const SEO = ({ 
  title, 
  description, 
  image = "https://kaynin.ma/og-image.jpg", // Default image (assumes it will exist)
  url = "https://kaynin.ma" 
}: SEOProps) => {
  const adminTitle = useSettingsStore(state => state.getSetting('kaynin_site_title', "Kayn'in_ⴽⴰⵢⵏⵉⵏ_كاينين"));
  const adminDesc = useSettingsStore(state => state.getSetting('kaynin_site_description', "Plateforme citoyenne nouvelle génération pour une démocratie participative active et un engagement citoyen au Maroc. منصة مواطنة من الجيل الجديد لديمقراطية تشاركية فاعلة وإلتزام مواطن في المغرب"));
  
  const finalTitle = title || (adminTitle as string);
  const finalDesc = description || (adminDesc as string);

  return (
    <Helmet>
      {/* Balises Méta de Base */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />

      {/* OpenGraph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Kayn'in" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
